import type { SourceStats } from '@fitness-force/models';

export const SOURCE_STATS_STATE:SourceStats =   {
    source:[],
    channel:'',
    total_sources:0
} 